module.exports = __webpack_public_path__ + "img/shiraz31458.16c1ffc1.jpg";